const heroSectionData = [
  {
    title: "A dynamic ecosystem where talent ",
    titletwo: "and opportunities converge",
  },
];

export default heroSectionData;
